import useLayoutStore from '@src/stores/layout'
import type { GlobalContext } from '@src/types/GlobalContext'

export default (cntx: GlobalContext) => {
    const i18n = cntx.i18n
    const pinia = cntx.pinia
    // @ts-ignore
    const messages = { ...i18n.global.messages.value }

    const layoutStore = useLayoutStore(pinia)
    // for (const lang in messages) {
    //     const clone = messages[lang]
    //     clone['Client']['routes']['ClientManager'] = function (cntx: any) {
    //         const str = i18n.global.t(
    //             'Client.model.' + layoutStore.clientType,
    //             2
    //         )
    //         return str
    //     }
    //     clone['Client']['routes']['Clients_Folder'] = function (cntx: any) {
    //         return i18n.global.t('Client.routes.Clients_Folder_T', {
    //             model: i18n.global.t(
    //                 'Client.model.' + layoutStore.clientType,
    //                 2
    //             ),
    //         })
    //     }
    //     i18n.global.setLocaleMessage(lang, clone)
    // }
}
